import ExchangeForm from './exchange_form';
import ExchangeValidator from './exchange_validator';

const exchangeValidator = () => {
  const newExchangeValidator = new ExchangeValidator();
}

const setupExchangeForm = (notice) => new ExchangeForm(notice).init();

const Contact = {
  exchangeValidator,
  setupExchangeForm,
};

export default Contact;
